var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30mm",
    height: 95.618,
    viewBox: "0 0 30 25.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#57433c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.081,
    d: "M29.267.106c-.16 2.05-1.253 3.891-2.318 5.65-.778 1.284-1.612 2.625-2.922 3.36-1.054.59-4.414 1.767-6.066.573-1.7-1.23-1.77-2.97-1.77-2.97h-2.487s-.07 1.74-1.77 2.97c-1.652 1.194-5.013.018-6.067-.573-1.309-.735-2.143-2.076-2.921-3.36C1.88 3.996.788 2.155.628.105-.067 4.48-.237 11.136.99 13.313l.18-.64a6.919 6.919 0 001.984 3.88v-.731c.8 1.414 1.46 2.814 2.96 3.851-.013-.306-.028-.612-.044-.918.714 1.198 1.642 2.087 2.987 3.003-.002-.149-.007-.297-.009-.445.52.717 1.185 1.513 2.186 2.088.064-.185-.046-.355.018-.54.84 1.075 3.697 2.31 3.697 2.31s2.857-1.235 3.697-2.31c.063.185-.046.355.018.54 1.001-.575 1.666-1.371 2.185-2.088-.002.148-.005.297-.009.445 1.346-.916 2.274-1.805 2.988-3.003l-.046.918c1.501-1.037 2.161-2.437 2.96-3.851l.001.73a6.918 6.918 0 001.984-3.88l.18.641c1.227-2.176 1.056-8.833.361-13.207"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeard);
export default __webpack_public_path__ + "static/media/beard.56d806d7207446f0700999898d0ea053.svg";
export { ForwardRef as ReactComponent };